module.exports = __webpack_public_path__ + "static/img/7839_phase_function_Paper_Points.c5f96d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7839_phase_function_Paper_Points.png
// module id = 8Hoz
// module chunks = 0